// Import 3rd-party dependencies
import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Import project-specific dependencies
import { InsightsService } from '@app/core/analytics/services/app-insights-service';
import { PeopleService } from '@app/services/people/people.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [InsightsService, PeopleService]
})
export class AnalyticsModule {
  static injector: Injector;

  constructor(injector: Injector) {
    AnalyticsModule.injector = injector;
  }

  static forRoot(analytics: InsightsService): ModuleWithProviders<AnalyticsModule> {
    return {
      ngModule: AnalyticsModule,
      providers: [
        {
          provide: { InsightsService, PeopleService },
          useValue: analytics
        }
      ]
    };
  }
}
